import React from 'react'
import { HiArrowSmRight } from 'react-icons/hi';
import * as S from './CustomerSlider.elements';
import slider1 from '../../assets/img/contact/slider1.jpg';
import slider2 from '../../assets/img/contact/slider2.jpg';
import slider3 from '../../assets/img/contact/slider3.jpg';
import decoration from '../../assets/img/decorations/deco-half-circle.svg';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Heading from "../Heading/Heading";
import Text from "../Text/Text";
import Container from "../Container/Container";
import Button from "../Button/Button";
import {useCurrentLangCode} from "../../hooks/useCurrentLangCode";

const CustomerSlider = ({data}) => {
    const {langForInUrl} = useCurrentLangCode();

    const settings = {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: true,
    };

    return (
        <S.StyledCustomerSlider>
            <Container>
                <S.Flex>
                    <S.StyledSlider {...settings}>
                        <S.Slide>
                            <img src={slider1} alt="" />
                        </S.Slide>
                        <S.Slide>
                            <img src={slider2} alt="" />
                        </S.Slide>
                        <S.Slide>
                            <img src={slider3} alt="" />
                        </S.Slide>
                    </S.StyledSlider>
                    <S.Content>
                        <div>
                            <Heading tag="h2">{data[0]?.sliderTitle}</Heading>
                            <Text>{data[0]?.sliderText}</Text>
                            <Button $onPrimary="true" to={`${langForInUrl}/${data[0]?.sliderButtonLink}`}>{data[0]?.sliderButtonLabel} <HiArrowSmRight/></Button>
                        </div>
                        <S.Decoration src={decoration} draggable="false" loading="lazy" alt="" />
                    </S.Content>
                </S.Flex>
            </Container>
        </S.StyledCustomerSlider>
    )
}

export default CustomerSlider
